import React, { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../api/baseurl";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router";
import "./hm-theme.css";

const RescheduleDoctorAppointment = ({ isOpen, onRequestClose, doctorAppointmentId }) => {
  const [newDate, setNewDate] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const userRole = JSON.parse(localStorage.getItem("data")).role;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newDate) {
      toast.warn("Please select a date");
      return;
    }
    const selectedDate = new Date(newDate);
    const currentDate = new Date();
    if (userRole !== 'ROLE_SUPER' && userRole !== 'ROLE_ADMIN') {
      if (selectedDate <= currentDate) {
        toast.warn("Please select a date after today.");
        return;
      }
    }
    if (selectedDate.getDay() === 0) {
      toast.warn("Please select a weekday other than Sunday.");
      return;
    }
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    try {
      await axios.post("/api/doctorappointment/accept-or-reschedule", {
        id: `${doctorAppointmentId}`,
        appointmentstatus: "APPOINTMENT RESCHEDULED",
        appointmentDate: newDate
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Doctor Appointment rescheduled successfully.");
      onRequestClose();
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">event_repeat</i>
          Reschedule Doctor Appointment
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-2 p-2 rounded-3 d-flex align-items-center gap-2" style={{ background: "rgba(44,182,233,0.08)", border: "1px solid rgba(44,182,233,0.2)" }}>
            <i className="material-icons text-info" style={{ fontSize: "1rem" }}>info</i>
            <span className="small text-muted">Sundays are not available for doctor appointments.</span>
          </div>

          <div className="mb-4 mt-3">
            <label htmlFor="newDate" className="form-label small fw-semibold">
              Select New Appointment Date <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              id="newDate"
              type="date"
              value={newDate}
              onChange={(e) => setNewDate(e.target.value)}
              min={new Date().toISOString().split("T")[0]}
              required
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>event_repeat</i>
              Confirm Reschedule
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default RescheduleDoctorAppointment;
